import { CURATED_EMOJI_OPTIONS } from "components/common/curatedEmojiOptions";

const allowed = new Set(CURATED_EMOJI_OPTIONS);

/** Strips emoji variation selector (U+FE0F) so API/browser variants still match the curated list. */
function emojiCompareKey(s: string): string {
  return s.normalize("NFC").replace(/\uFE0F/g, "");
}

const allowedKeys = new Map<string, string>();
for (const opt of CURATED_EMOJI_OPTIONS) {
  allowedKeys.set(emojiCompareKey(opt), opt);
}

export function normalizeCustomerEmoji(raw: string | null | undefined): string | undefined {
  const t = raw?.trim();
  if (!t) return undefined;
  if (allowed.has(t)) return t;
  const canon = allowedKeys.get(emojiCompareKey(t));
  return canon;
}

/** Raw `emoji` from JSON (some stacks may use `Emoji`). */
export function rawCustomerEmojiFromApi(
  cust: { emoji?: string | null } & { Emoji?: string | null },
): string | null | undefined {
  return cust.emoji ?? cust.Emoji ?? undefined;
}
